var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":_vm.img}}),_c('p',[_vm._v("未到找指定页面")])])
}
var staticRenderFns = []

export { render, staticRenderFns }